import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/scheduleHotelActivity'

export const scheduleHotelActivityService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem
};

//show
function getItem(idPlace) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${idPlace}`, 'GET', {showAlert:false})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data:data});
}

//update
function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

//delete
function deleteItem(id, db=null) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}